import { dateToday, stringToDate } from 'helpers/date';

const validateClientAge = (operator, birthDate, ageThreshold) => {
  if (operator === 'ge') {
    const today = dateToday().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const birthDateNormalized = stringToDate(birthDate);
    const ages = today.diff(birthDateNormalized, 'years');
    if (ages >= parseInt(ageThreshold, 10)) {
      return true;
    }
    return false;
  }
};

export { validateClientAge as default };
